import { useEffect, useState } from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FieldType } from '../../types';
import { FormattedMessage } from 'react-intl';
import { TermsAndConditionsModal } from './TermsAndConditionsModal';


export const DefaultCheckboxText = ({
  locale,
  itemData,
  value,
  isInvalid,
  externalData,
  handleAccept,
}: {
  locale: string;
  itemData: FieldType;
  value: boolean;
  isInvalid: boolean;
  externalData: any;
  handleAccept: () => void;
}) => {
  const classes = useStyles();

  const [isTermsAndConditionsViewed, setIsTermsAndConditionsViewed] = useState(false);
  const [isTermsAndConditionsModalOpen, setIsTermsAndConditionsModalOpen] = useState(false);

  useEffect(() => {
    if (isTermsAndConditionsModalOpen) {
      setIsTermsAndConditionsViewed(true);
    }
  }, [isTermsAndConditionsModalOpen]);

  return <>
    <FormControlLabel
      control={
        <Checkbox
          value={value}
          name={itemData.config.fieldName}
          checked={value}
          onChange={handleAccept}
        />
      }
      onClick={() => (itemData.config.requireTermsAndConditionsView && !isTermsAndConditionsViewed) ? setIsTermsAndConditionsModalOpen(true) : ''}
      className={classes.iAcceptText}
      label={
        <div style={{ color: isInvalid ? '#d32f2f' : 'inherit' }}>
          <FormattedMessage id={'iAccept'} defaultMessage={'iAccept'} />
          {' '}
          <span
            className={classes.termsAndConditionText}
            onClick={() => setIsTermsAndConditionsModalOpen(true)}
          >
            <FormattedMessage
              id={'termsAndCondition'}
              defaultMessage={'termsAndCondition'}
            />
          </span>
          {' *'}
        </div>
      }
    />

    <TermsAndConditionsModal
      locale={locale}
      itemData={itemData}
      externalData={externalData}
      isTermsAndConditionsModalOpen={isTermsAndConditionsModalOpen}
      setIsTermsAndConditionsModalOpen={setIsTermsAndConditionsModalOpen}
    />
  </>
};


const useStyles = makeStyles(() => ({
  iAcceptText: {
    fontWeight: 'lighter',
    margin: '0 4px 0 0 !important',
    display: 'inline-block',
  },
  termsAndConditionText: {
    fontWeight: 'bolder',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}));
